export type LoggerConsole = typeof console
export type Logger = LoggerConsole & {
  new: (prefix: string) => Logger
}

export let logger = new Proxy(console, {
  get(_, prop) {
    if (prop === 'new') {
      return () => logger // return the same noop logger proxy
    }

    return () => {
      // do nothing
    }
  },
}) as Logger

export function setLogger(newLogger: any) {
  logger = newLogger
}

export function createLogger(name: string): Logger {
  let instance: Logger | undefined
  const getInstance = () => instance ?? (instance = logger.new(name))

  return new Proxy({} as Logger, {
    get(_, prop) {
      const real = getInstance()
      const value = real[prop]

      if (typeof value === 'function') {
        return value.bind(real)
      }

      return value
    },
  })
}
